module.exports = __webpack_public_path__ + "assets/img/bank1.7fb49b24.svg";